const ACTION = {
    UPDATE_HISTORICAL_CONTACT_PERSON: 'UPDATE_HISTORICAL_CONTACT_PERSON',
    UPDATE_HISTORICAL_CONTACT_PERSON_ERROR_TEXT: 'UPDATE_HISTORICAL_CONTACT_PERSON_ERROR_TEXT',
    UPDATE_HISTORICAL_CONTACT_PERSON_ERROR_TEXT_BY_INDEX: 'UPDATE_HISTORICAL_CONTACT_PERSON_ERROR_TEXT_BY_INDEX'
}

export default ACTION;